var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    '-insert-your-own-gap',
    '-gap',
    'wt2-link',
    _vm.guid,
    { '-irrelevant': !_vm.isRelevant, '-singleGap': _vm.isSingleGap } ],attrs:{"title":_vm.text},domProps:{"textContent":_vm._s(_vm.text)},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }